export default "__VITE_ASSET__BFuq_Ep6__";